/**
 *
 * @param {*} urlStr
 * @param {*} base
 * @returns
 */
function parseUrl(urlStr, base) {
  if (typeof URL !== 'undefined' && 'parse' in URL) {
    return URL.parse(urlStr, base);
  }
  try {
    if (typeof URL === 'undefined') throw new Error('No URL constructor');
    return new URL(urlStr, base);
  } catch (err) {
    return null;
  }
}

/**
 *
 * @param {*} urlStr
 * @param {*} base
 * @returns
 */
function getSearchParams(urlStr, base) {
  const urlObj = parseUrl(urlStr, base);
  if (!urlObj) return new URLSearchParams('');
  return urlObj.searchParams;
}

/**
 * 获取url参数
 * 没传参时获取所有参数
 * @param {*} key
 * @returns
 */
function getUrlParams(key) {
  let params = getSearchParams(window.location.href);
  if (key) {
    return params.get(key);
  }
  let keys = Array.from(params.keys());
  let paramsObj = {};
  for (let key of keys) {
    paramsObj[key] = params.get(key);
  }
  return paramsObj;
}

export { parseUrl, getSearchParams, getUrlParams };
